export const COLLECTING_ENTITIES_REPORT_TYPES = {
  SUMMARY: 'bank_collections_summary',
  INTERMEDIATE: 'intermediate_entities_collection',
};

export const COLLECTING_ENTITIES_REPORT_OPTIONS = [
  { value: COLLECTING_ENTITIES_REPORT_TYPES.SUMMARY, label: 'Resumen' },
  { value: COLLECTING_ENTITIES_REPORT_TYPES.INTERMEDIATE, label: 'Recaudación' },
];

export const INITIAL_FILTERS = {
  reportType: COLLECTING_ENTITIES_REPORT_TYPES.SUMMARY,
  dateStart: '',
  dateEnd: '',
  plan: 'all',
  legalEntity: 'all',
  group: 'all',
  orderNumber: '',
  whitHouse: 'not_selected',
};

export const MESSAGES = {
  ERROR: {
    FETCH_DATA: 'Error al obtener el resumen de cobranzas.',
    INVALID_RANGE: 'La fecha desde no puede ser mayor que la fecha hasta.',
    DATES_REQUIRED: 'Debe ingresar Fecha Desde y Fecha Hasta.',
    LEGAL_ENTITY_REQUIRED: 'Debe seleccionar una entidad intermedia.',
  },
  EMPTY_STATE: 'No se encontraron datos con los filtros seleccionados.',
};
